import { useLazyQuery } from "@apollo/client/react";
import React, { Fragment, useEffect, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { CustomChip } from "../../../components/chip/Chip";
import { Box, Grid, CardContent, Card } from '@mui/material';

import { GET_ALL_EVALUACIONES_BY_PACIENTE } from '../../../data/graphQL/queries/ResumenIngresoValidation/getAllEvaluacionesByPaciente';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import '../../RIValidationSearch/components/riValidationSearch.scss';

export const ContratosPaciente = ({ idPaciente, setContratosIds }) => {
  const [contratos, setContratos] = useState([]);
  const navigate = useNavigate();
  const [estadosChip] = useState({
    'Pendiente': { isYellow: true },
    'Aprobado': { isGreen: true },
    'Rechazado': { isRed: true }
  });

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 0.0005,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return <>
          {!!row?.idRI &&
            <PopoverModal>
              <div className='popover-modal-content'>
                <div onClick={() => handleClickView(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver RI</span>
                </div>
              </div>
            </PopoverModal>
          }
        </>;
      }
    },
    {
      flex: 0.0013,
      field: 'delegacion',
      align: 'center',
      headerAlign: 'center',
      headerName: 'Delegacion'
    },
    {
      flex: 0.0013,
      field: 'idEvaluacion',
      align: 'center',
      headerAlign: 'center',
      headerName: 'Nro Contrato'
    },
    {
      flex: 0.0015,
      field: 'programa',
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => {
        return <div className="center"> {row?.programa || '-'}</div>;
      },
      headerName: 'Programa'
    },
    {
      flex: 0.0015,
      field: 'idRI',
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => {
        return <div className="center"> {row?.idRI || '-'}</div>;
      },
      headerName: 'RI nro'
    },
    {
      flex: 0.0013,
      field: 'estadoRI',
      headerName: 'Estado RI',
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => {
        const color = estadosChip[row?.estadoRI];
        return (
          row?.estadoRI ?
            <CustomChip
              label={row?.estadoRI}
              {...color} /> :
            <div className='center'>-</div>);

      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const handleClickView = (row) => {
    navigate('/resumenIngreso/crearResumenIngreso',
      {
        state: {
          idDatosGeneralesRI: row.idRI,
          edit: false
        }
      });
  };

  const [getContratos, { loading: contratosLoading, data: contratosData }] = useLazyQuery(GET_ALL_EVALUACIONES_BY_PACIENTE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!contratosData) return;

    setContratos(contratosData.allEvaluacionesByPaciente?.valorEsperado);
    setContratosIds(contratosData.allEvaluacionesByPaciente?.valorEsperado?.map((contrato) => contrato.idEvaluacion));
  }, [contratosData]);

  useEffect(() => {
    if (!!idPaciente)
      getContratos({ variables: { idPaciente } });
  }, [idPaciente]);

  return <>
    <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
      <CardContent>
        <h4>Contratos del Paciente</h4>
        <DataGridGenerico
          columns={columns}
          rows={contratos || []}
          toolbar={false}
          loading={contratosLoading} />

      </CardContent>
    </Card>
  </>;
};